import { call, put, takeLatest } from "redux-saga/effects";
import * as types from "../actions/actionTypes";
import { FileAction } from "../actions";
import * as fileApi from "../api/file";
import { toastr } from "react-redux-toastr";
import checkErrorMessagesExist from "../assets/checkErrorMessagesExist";
import { SetMessage } from "../assets/errorMessages";
import { goBack } from "connected-react-router";
import { createBrowserHistory } from "history";
import { PAGE_NUM } from "../constants/filters";

export function* watcherFile() {
  yield takeLatest(types.GET_FILES_REQUEST, list);
  yield takeLatest(types.REMOVE_FILE_REQUEST, remove);
}

function fetchList(pageNumber) {
  return fileApi.get(pageNumber);
}

function* list(action) {
  try {
    const response = yield call(fetchList, action.pageNumber);
    response.data.message.forEach(message => {
      toastr.success(" ", message.toString());
    });
    yield put(FileAction.getFileSuccess(response.data));
  } catch (error) {
    const message = SetMessage(error);
    yield put(FileAction.getFileFailure(message));
  }
}

function removeRequest(id) {
  return fileApi.remove(id);
}

function* remove(action) {
  try {
    const response = yield call(removeRequest, action.id);
    response.data.message.forEach(message => {
      toastr.success(" ", message.toString());
    });
    const history = createBrowserHistory();
    const urlParams = new URLSearchParams(window.location.search);
    const pNum = urlParams.get(PAGE_NUM);
    if (pNum !== action.pageNumber) {
      urlParams.set(PAGE_NUM, action.pageNumber);
      history.push({ search: urlParams.toString() });
    }
    yield put(FileAction.removeFileSuccess(action.id));
  } catch (error) {
    SetMessage(error, true);
    yield put(FileAction.removeFileFailure(action.id));
  }
}
